












import { defineComponent, computed } from '@vue/composition-api';

const CommonToggleButton = defineComponent({
  setup(props: any) {
    function computedClass(key: any) {
      if (key === props.value) return 'primary';
      return 'gray';
    }

    function getFirstAndLastButtonClass(index: any) {
      if (index === props.list.length - 1) return 'right-btn';
      if (index === 0) return 'left-btn';
      return 'center-btn';
    }

    return {
      getFirstAndLastButtonClass,
      computedClass,
    };
  },
  props: {
    list: {
      required: true,
      type: Array,
    },
    // 1 element of list -> { value: '', display: '' }
    value: {
      required: true,
    },
  },
});

export default CommonToggleButton;
